const Backend = {
  install (Vue, apiClient) {
    Vue.prototype.$backend = apiClient
  }
}

export default Backend



// WEBPACK FOOTER //
// ./src/helpers/backend.js